export type LanguageCode =
  'fr' | 'en' | 'es' | 'de' | 'it' | 'pt' | 'nl' | 'pl' | 'ru' | 'tr' | 'ar' | 'zh' | 'ja' | 'ko' | 'hi';

export interface Language {
  code: LanguageCode;
  // Nom de la langue dans la langue elle-même (affiché tel quel dans le sélecteur)
  nativeName: string;
  dir: 'ltr' | 'rtl';
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'fr', nativeName: 'Français', dir: 'ltr' },
  { code: 'en', nativeName: 'English', dir: 'ltr' },
  { code: 'es', nativeName: 'Español', dir: 'ltr' },
  { code: 'de', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'it', nativeName: 'Italiano', dir: 'ltr' },
  { code: 'pt', nativeName: 'Português', dir: 'ltr' },
  { code: 'nl', nativeName: 'Nederlands', dir: 'ltr' },
  { code: 'pl', nativeName: 'Polski', dir: 'ltr' },
  { code: 'ru', nativeName: 'Русский', dir: 'ltr' },
  { code: 'tr', nativeName: 'Türkçe', dir: 'ltr' },
  { code: 'ar', nativeName: 'العربية', dir: 'rtl' },
  { code: 'zh', nativeName: '中文', dir: 'ltr' },
  { code: 'ja', nativeName: '日本語', dir: 'ltr' },
  { code: 'ko', nativeName: '한국어', dir: 'ltr' },
  { code: 'hi', nativeName: 'हिन्दी', dir: 'ltr' },
];

// Langue du rendu serveur (SSR) et des textes de référence
export const DEFAULT_LANGUAGE: LanguageCode = 'fr';

// Utilisée quand aucune des langues de l'appareil n'est supportée
export const FALLBACK_LANGUAGE: LanguageCode = 'en';

export function findLanguage(code: string | null | undefined): Language | undefined {
  if (!code) {
    return undefined;
  }
  const base = code.toLowerCase().split('-')[0];
  return SUPPORTED_LANGUAGES.find(l => l.code === base);
}
